<template>
    <b-card no-body :header="title" class="mb-2" border-variant="primary" header-bg-variant="primary"
            header-text-variant="white">
        <div>
            <div class="text-center my-3 ScoreCircle mx-auto d-flex align-items-center ">
                <h1 class="display-2 mx-auto m-0">{{ score }}<span class="h3 text-primary">分</span></h1>
            </div>
            <h3 class="text-center">整體勝率</h3>
        </div>
        <hr>
        <b-list-group flush>
            <b-list-group-item v-for="(item , index) in listdata" v-bind:key="index">{{ item.result }}</b-list-group-item>
        </b-list-group>
    </b-card>
</template>
<script>

export default {
  name: 'PhoneResultCard',
  props: {
    listdata: Array,
    title: String,
    score: Number
  },
  data () {
    return {}
  },
  methods: {}
}
</script>
<style>

    .ScoreCircle {
        height: 50vw;
        max-height: 200px;
        max-width: 200px;
        width: 50vw;

        border-color: #be9167 !important;
        border: 1px solid rgba(0, 0, 0, 0.125);
        border-radius: 50rem;
    }
</style>
